<template>
  <div class="cards">
    <!-- <h4>Horizontal Flip</h4> -->
    <div class="flip">
      <div
        class="front"
        style="
          background-image: url(https://oopvr-client.oss-cn-shenzhen.aliyuncs.com/images/1.jpg);
        "
      >
        <h1 class="text-shadow">每日动态</h1>
      </div>
      <div class="back">
        <h2>---</h2>
        <p>
          不要为已结束的过去而后悔，
          <br />
          也不要沉醉于稍纵即逝的现在。
        </p>
        <br />

        <p>
          <router-link to="/timemachine"
            ><a-button ghost> 立即前往<a-icon type="right" /> </a-button
          ></router-link>
        </p>
      </div>
    </div>
    <div class="flip">
      <div
        class="front"
        style="
          background-image: url(https://oopvr-client.oss-cn-shenzhen.aliyuncs.com/images/2.jpg);
        "
      >
        <h1 class="text-shadow">资源共享</h1>
      </div>
      <div class="back">
        <h2>需求/供应</h2>
        <p>
          如有所需，既有所供。
          <br />
          按需所供，等价交换。
        </p>
        <br />
        <router-link to="/special"
          ><a-button ghost> 立即前往<a-icon type="right" /> </a-button
        ></router-link>
      </div>
    </div>
    <div class="flip">
      <div
        class="front"
        style="
          background-image: url(https://oopvr-client.oss-cn-shenzhen.aliyuncs.com/images/3.jpg);
        "
      >
        <h1 class="text-shadow">领域架构</h1>
      </div>
      <div class="back">
        <h2>韩非子·外储说左上</h2>
        <p>
          车輗者巧也。
          <br />
          用咫尺之木，不费一朝之事，而引三十石之任，致远力多，久于岁数。
        </p>
        <br />
        <router-link to="/cloudstorys"
          ><a-button ghost> 立即前往<a-icon type="right" /> </a-button
        ></router-link>
      </div>
    </div>

    <br />
    <br />

    <!-- vertical -->

    <!-- <h4>Vertical Flip</h4>
    <div class="flip flip-vertical">
      <div
        class="front"
        style="
          background-image: url(https://images.pexels.com/photos/38136/pexels-photo-38136.jpeg?w=1260&h=750&dpr=2&auto=compress&cs=tinysrgb);
        "
      >
        <h1 class="text-shadow">FOREST</h1>
      </div>
      <div class="back">
        <h2>Angular</h2>
        <p>
          Good tools make application development quicker and easier to maintain
          than if you did everything by hand..
        </p>
      </div>
    </div>
    <div class="flip flip-vertical">
      <div
        class="front"
        style="
          background-image: url(https://images.pexels.com/photos/34950/pexels-photo.jpg?w=1260&h=750&dpr=2&auto=compress&cs=tinysrgb);
        "
      >
        <h1 class="text-shadow">TRACK</h1>
      </div>
      <div class="back">
        <h2>Angular</h2>
        <p>
          Good tools make application development quicker and easier to maintain
          than if you did everything by hand..
        </p>
      </div>
    </div>
    <div class="flip flip-vertical">
      <div
        class="front"
        style="
          background-image: url(https://images.pexels.com/photos/34546/sunset-lake-landscape-summer.jpg?w=1260&h=750&dpr=2&auto=compress&cs=tinysrgb);
        "
      >
        <h1 class="text-shadow">SWAMP</h1>
      </div>
      <div class="back">
        <h2>Angular</h2>
        <p>
          Good tools make application development quicker and easier to maintain
          than if you did everything by hand..
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>

import one from "@/images/ArticlesCoverChart/1.jpg";
export default {
  name: "marvellous",
  data() {
    return {
      name: "精彩动态",
    };
  },

  mounted() {},
  methods: {},
};
</script>

<style lang="less">
// font stuff
@import (css) "https://fonts.googleapis.com/css?family=Roboto+Mono";

.cards {
  // color: #555;
  // background: #222;
  margin-top: 600px;
  text-align: center;
  font-family: "Roboto Mono";
  padding: 1em;
  * {
    box-sizing: border-box;
    font-weight: normal;
  }

  // body {

  // }

  h1 {
    font-size: 2.2em;
    color: rgb(240, 214, 214);
  }

  h2 {
    font-size: 1.2em;
    color: rgb(236, 207, 110);
  }

  // base
  .flip {
    position: relative;
    > .front,
    > .back {
      display: block;
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
      transition-duration: 0.5s;
      transition-property: transform, opacity;
    }
    > .front {
      transform: rotateY(0deg);
    }
    > .back {
      position: absolute;
      opacity: 0;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      transform: rotateY(-180deg);
    }
    &:hover {
      > .front {
        transform: rotateY(180deg);
      }
      > .back {
        opacity: 1;
        transform: rotateY(0deg);
      }
    }
    &.flip-vertical {
      > .back {
        transform: rotateX(-180deg);
      }
      &:hover {
        > .front {
          transform: rotateX(180deg);
        }
        > .back {
          transform: rotateX(0deg);
        }
      }
    }
  }

  // custom
  .flip {
    position: relative;
    display: inline-block;
    margin-right: 2px;
    margin-bottom: 1em;
    width: 500px;
    // width: 50%;
    > .front,
    > .back {
      display: block;
      color: white;
      width: inherit;
      background-size: cover !important;
      background-position: center !important;
      height: 220px;
      padding: 2.5em 2em;
      background: #313131;
      // background: #e3bae9;
      border-radius: 10px;
      p {
        font-size: 0.9125rem;
        line-height: 160%;
        color: rgb(153, 153, 153);
      }
    }
  }

  .text-shadow {
    text-shadow: 1px 1px rgba(0, 0, 0, 0.04), 2px 2px rgba(0, 0, 0, 0.04),
      3px 3px rgba(0, 0, 0, 0.04), 4px 4px rgba(0, 0, 0, 0.04),
      0.125rem 0.125rem rgba(0, 0, 0, 0.04), 6px 6px rgba(0, 0, 0, 0.04),
      7px 7px rgba(0, 0, 0, 0.04), 8px 8px rgba(0, 0, 0, 0.04),
      9px 9px rgba(0, 0, 0, 0.04), 0.3125rem 0.3125rem rgba(0, 0, 0, 0.04),
      11px 11px rgba(0, 0, 0, 0.04), 12px 12px rgba(0, 0, 0, 0.04),
      13px 13px rgba(0, 0, 0, 0.04), 14px 14px rgba(0, 0, 0, 0.04),
      0.625rem 0.625rem rgba(0, 0, 0, 0.04), 16px 16px rgba(0, 0, 0, 0.04),
      17px 17px rgba(0, 0, 0, 0.04), 18px 18px rgba(0, 0, 0, 0.04),
      19px 19px rgba(0, 0, 0, 0.04), 1.25rem 1.25rem rgba(0, 0, 0, 0.04);
  }

  @media only screen and (max-width: 480px) {
    .flip {
      width: 350px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bottonconfig/marvellous.vue